import { useParams } from 'react-router-dom';
import { Form } from '@ant-design/compatible';
import type { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { useCouponDetail } from '../../../hooks/coupon/useCouponDetail';
import CouponDetailStatistics from '../../coupon/detail/CouponDetailStatistics';
import CouponDetailInfo from '../../coupon/detail/CouponDetailInfo';
import CouponDetailNavbar from '../../coupon/detail/CouponDetailNavbar';
import { CouponDetailWrapStyle } from './style';

const CouponDetailWrapInner = (props: { form: WrappedFormUtils }) => {
  const { form } = props;
  const { id } = useParams<{ id: string }>();
  const couponId = Number(id);

  const {
    isLoading,
    couponDetail,
    getCouponUsageHistoryList,
    getCouponUsageHistoryListExcelDownload,
    getCouponUnUsageHistoryList,
    getCouponUnUsageHistoryListExcelDownload,
    getCouponProductLinkList,
    getCouponBrandLinkList,
    toggleModal,
    getProductSubCategoryList,
  } = useCouponDetail(couponId);

  const {
    couponInfo,
    couponStatistics,
    couponUsageHistory,
    couponUnUsageHistory,
    couponProductLink,
    mainProductCategorySelectList,
    subProductCategorySelectList,
    couponBrandLink,
  } = couponDetail;

  if (isLoading) return null;

  return (
    <CouponDetailWrapStyle className="coupon-detail-wrap">
      {/* 하단 네브바 */}
      <CouponDetailNavbar couponId={couponInfo.couponId} />

      {/* 쿠폰 통계 */}
      <CouponDetailStatistics couponInfo={couponInfo} couponStatistics={couponStatistics} />

      {/* 쿠폰 정보 */}
      <CouponDetailInfo
        form={form}
        toggleModal={toggleModal}
        mainProductCategorySelectList={mainProductCategorySelectList}
        subProductCategorySelectList={subProductCategorySelectList}
        couponInfo={couponInfo}
        couponUsageHistory={couponUsageHistory}
        couponUnUsageHistory={couponUnUsageHistory}
        couponProductLink={couponProductLink}
        couponBrandLink={couponBrandLink}
        getCouponUsageHistoryList={getCouponUsageHistoryList}
        getCouponUsageHistoryListExcelDownload={getCouponUsageHistoryListExcelDownload}
        getCouponUnUsageHistoryList={getCouponUnUsageHistoryList}
        getCouponUnUsageHistoryListExcelDownload={getCouponUnUsageHistoryListExcelDownload}
        getCouponProductLinkList={getCouponProductLinkList}
        getCouponBrandLinkList={getCouponBrandLinkList}
        getProductSubCategoryList={getProductSubCategoryList}
      />
    </CouponDetailWrapStyle>
  );
};

export const CouponDetailWrap = Form.create()(CouponDetailWrapInner) as React.ComponentType;
